// SLICK SLIDER
(function ($) {
	$(".img-slider-wrapper").slick({
		arrows: false,
        fade: true,
        dots: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 5000,
	});

    $(".featured-prod-slider").slick({
		arrows: false,
        fade: true,
        dots: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 5000,
	});

  //  $(".review-slider-wrapper").slick({
  // 	arrows: false,
  // 	fade: false,
  // 	dots: false,
  // 	infinite: true,
  // 	slidesToShow: 4,
  // 	slidesToScroll: 1,
  // 	adaptiveHeight: false,
  // 	autoplay: true,
  // 	autoplaySpeed: 5000,
  // 	responsive: [
  // 		{
  // 			breakpoint: 900, // Screens smaller than 900px
  // 			settings: {
  // 				slidesToShow: 3,
  // 			}
  // 		},
  // 		{
  // 			breakpoint: 768, // Screens smaller than 768px
  // 			settings: {
  // 				slidesToShow: 1,
  // 			}
  // 		},
  // 		{
  // 			breakpoint: 320, // Screens smaller than 320px
  // 			settings: {
  // 				slidesToShow: 1,
  // 			}
  // 		}
  // 	]
  // });

// $(".featured-prod-blocks-slider").slick({
//     arrows: true,
//     fade: false,
//     dots: false,
//     infinite: true,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     adaptiveHeight: false,
//     autoplay: true,
//     autoplaySpeed: 5000,
//     prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
//     nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
//     responsive: [
//         {
//             breakpoint: 900, // Screens smaller than 900px
//             settings: {
//                 slidesToShow: 3,
//             }
//         },
//         {
//             breakpoint: 768, // Screens smaller than 768px
//             settings: {
//                 slidesToShow: 1,
//             }
//         },
//         {
//             breakpoint: 320, // Screens smaller than 320px
//             settings: {
//                 slidesToShow: 1,
//             }
//         }
//     ]
// });
  
// Handle syncing between the sliders to ensure they slide at the same time when dragged
$('.banner-image-slider-block').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.text-slider-block').slick('slickGoTo', nextSlide);
});

$('.text-slider-block').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.banner-image-slider-block').slick('slickGoTo', nextSlide);
});


$(document).ready(function() {
  $("[data-fancybox]").fancybox({
    // Optional Fancybox options
    iframe: {
      css: {
        width: '80%',
        height: '80%'
      }
    }
  });
});

	
})(jQuery);